export const IACET_IMG =
  'https://acma-media-bucket.s3.us-east-2.amazonaws.com/images/brand/complaintPortal/logos/Iacet.png';

export const SUCCESS_THANK_YOU =
  'https://acma-media-bucket.s3.us-east-2.amazonaws.com/images/brand/complaintPortal/ThankYou.png';

export const PHARMA_IMAGE =
  'https://acma-media-bucket.s3.us-east-2.amazonaws.com/images/brand/complaintPortal/Pharmaceutical-professionals-meeting.jpg';
